// extracted by mini-css-extract-plugin
module.exports = {"desktop":"Responsive_desktop__jv0j1","mobile":"Responsive_mobile__Wfk53"};